/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Phase_ScanInputs */



/**
* | output |
* | --- |
* | "Reading" |
*
* @param {Embed_Captions_Local_Phase_ScanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_phase_scan = /** @type {((inputs?: Embed_Captions_Local_Phase_ScanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Phase_ScanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En lisant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lektüre")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lettura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Чтение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lectura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阅读")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पढ़ना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Leitura")
	return /** @type {LocalizedString} */ ("Reading")
});